import {toDate} from "../helpers/helpers";

export interface CreditCheckResponse {
  creditSegmentInternalId: string;
  indicator: boolean;
  checkingDescription: {
    languageCode: string;
    messages: string [];
  };
  debtorPartyBlockedIndicator?: boolean;
  debtorPartySpecialAttentionRequiredIndicator?: boolean;
  debtorParty: {
    schemeId: string;
    schemeAgencyId: string;
    internalId: string;
  };
  rating: string;
  riskClass: string;
  creditLimit: {
    currencyCode: string;
    amount: number;
  };
  creditExposure: {
    currencyCode: string;
    amount: number;
  };
}

export interface CreditCheckLogModel {
  id: string;
  soldToBpId: string;
  payerBpId: string;
  billToBpId: string;
  projectId: string;
  currency: string;
  paymentTerm: string;
  totalContractValue: number;
  response: CreditCheckResponse;
  responseSuccess: boolean;
  notes: string;
  creditBlockReason: string;
  createdAt: Date;
  updatedAt: Date;
  error: string;
}

export function CreditCheckLogModelFactory(json?: any): CreditCheckLogModel {
  json = json || {};

  return ({
    id: json.id,
    soldToBpId: json.soldToBpId || "-",
    billToBpId: json.billToBpId || "-",
    payerBpId: json.payerBpId || "-",
    projectId: json.projectId || "",
    currency: json.currency || "",
    paymentTerm: json.paymentTerm || "",
    totalContractValue: json.totalContractValue || 0,
    response: json.response || null,
    responseSuccess: json.responseSuccess || false,
    notes: json.notes || null,
    creditBlockReason: json.creditBlockReason || "",
    createdAt: toDate(json.createdAt),
    updatedAt: toDate(json.updatedAt),
    error: json.error,
  });
}

export function creditCheckLogListModelFactory(array?: any): CreditCheckLogModel[] {
  array = array || [];
  return array.map(e => CreditCheckLogModelFactory(e));
}
